import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Delete package"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-3 mb-3" }, " This action is irreversible, are you sure you want to delete this entry? ")
], -1)
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-flex w-100 justify-content-end page-heading-toolbar" }
const _hoisted_4 = { class: "page-heading-toolbar--col" }
const _hoisted_5 = { class: "page-heading-toolbar--col" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = ["data-id"]
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center pt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditLocationPackageDialog = _resolveComponent("EditLocationPackageDialog")!
  const _component_DeleteConfirmDialog = _resolveComponent("DeleteConfirmDialog")!
  const _component_ShadowControl = _resolveComponent("ShadowControl")!
  const _component_SelectDropdown = _resolveComponent("SelectDropdown")!
  const _component_PageMainHeading = _resolveComponent("PageMainHeading")!
  const _component_CountryPackageCard = _resolveComponent("CountryPackageCard")!
  const _component_AppExpendedTable = _resolveComponent("AppExpendedTable")!
  const _component_AppTableController = _resolveComponent("AppTableController")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_EditLocationPackageDialog, {
      key: "EditLocationPackageDialog",
      "edit-data": _ctx.editData,
      opened: _ctx.createPackageDialogOpened,
      "is-edit": _ctx.isEditing,
      loading: _ctx.editLoading,
      operators: _ctx.selectedPlanOperators,
      "selected-location-name": _ctx.locationName,
      "selected-location-type": _ctx.currentLocationType,
      "traffic-list": _ctx.trafficAmountList,
      providers: _ctx.providers,
      onHide: _ctx.endPackageEditing,
      onSubmit: _ctx.updateSubmitHandler
    }, null, 8, ["edit-data", "opened", "is-edit", "loading", "operators", "selected-location-name", "selected-location-type", "traffic-list", "providers", "onHide", "onSubmit"]),
    _createVNode(_component_DeleteConfirmDialog, {
      opened: _ctx.deleteConfirmDialogOpened,
      loading: _ctx.deleteLoading,
      onHide: _ctx.deleteCancel,
      onCancel: _ctx.deleteCancel,
      onConfirm: _ctx.deleteConfirm
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["opened", "loading", "onHide", "onCancel", "onConfirm"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PageMainHeading, { title: _ctx.pageTitle }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ShadowControl, {
                id: "location-search",
                class: "search-control",
                icon: "search",
                placeholder: "Search...",
                name: "location-search",
                "input-timeout": true,
                onChange: _ctx.searchHandler
              }, null, 8, ["onChange"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SelectDropdown, {
                icon: "filter",
                list: _ctx.filter,
                "on-select": _ctx.onFilterSelect
              }, null, 8, ["list", "on-select"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _createVNode(_component_AppTableController, {
      "show-table": !!_ctx.rows.length,
      "search-query": _ctx.searchQuery,
      "empty-key": _ctx.currentSortKeyLocationName,
      "empty-icon": "packages",
      "table-loading": !!!_ctx.rows.length
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_AppExpendedTable, {
            "table-head": _ctx.tableHead,
            "table-body": _ctx.rows,
            "total-rows": _ctx.totalRowsCount,
            "pagination-capture-key": _ctx.currentSortKeyLocationName,
            "current-page": _ctx.viewConfiguration.page,
            "per-page": _ctx.viewConfiguration.perPage,
            onChangeViewConfiguration: _ctx.changeViewConfiguration,
            onSort: _ctx.changeSorting,
            onAccordionOpen: _ctx.onAccordionOpen
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationPackagesList, ({ plans, id, canExpended }) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: id,
                  class: "mb-1",
                  "data-id": id
                }, [
                  canExpended
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plans, (plan) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: plan.id,
                            class: "col-4 col-xxxl-3"
                          }, [
                            _createVNode(_component_CountryPackageCard, {
                              title: plan.name,
                              packages: plan.packages,
                              onAddPackage: ($event: any) => (_ctx.startPackageCreating(plan, plans)),
                              onEditPackage: 
                  data => {
                    _ctx.startPackageEditing(plan.planOperators, data);
                  }
                ,
                              onDeletePackage: _ctx.startDeleting
                            }, null, 8, ["title", "packages", "onAddPackage", "onEditPackage", "onDeletePackage"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_9, " The current region contains sub-regions. You can add packages to a sub-region. "))
                ], 8, _hoisted_7))
              }), 128))
            ]),
            _: 1
          }, 8, ["table-head", "table-body", "total-rows", "pagination-capture-key", "current-page", "per-page", "onChangeViewConfiguration", "onSort", "onAccordionOpen"])
        ])
      ]),
      _: 1
    }, 8, ["show-table", "search-query", "empty-key", "table-loading"])
  ], 64))
}